module.exports = __webpack_public_path__ + "assets/img/4.8a65ea34.jpg";